import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes, AppRoutesCombined } from '@sparrow-card/sparrow-card-constants';
import {
  importApply,
  importReinstatementApply,
  importStarlingApply,
  prefetchFinalPages,
} from 'routes/lazyPages';

const PRE_APPROVED_TO_APPLY: Record<string, () => Promise<unknown>> = {
  [AppRoutes.PreApproved]: importApply,
  [AppRoutesCombined.ReinstatementPreApproved]: importReinstatementApply,
  [AppRoutesCombined.StarlingPreApproved]: importStarlingApply,
};

const APPLY_PATHS = new Set([
  AppRoutes.Apply,
  AppRoutesCombined.ReinstatementApply,
  AppRoutesCombined.StarlingApply,
]);

const usePrefetchFunnelChunks = (): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    const loadNextApply = PRE_APPROVED_TO_APPLY[pathname];

    if (loadNextApply) {
      void loadNextApply();

      return;
    }

    if (APPLY_PATHS.has(pathname)) {
      prefetchFinalPages();
    }
  }, [pathname]);
};

export default usePrefetchFunnelChunks;
